export const SELECT_COIN = 'SELECT_COIN';
export const RESET_COIN = 'RESET_COIN';
export const SET_ENABLED_COINS = 'SET_ENABLED_COINS';
export const LOADING_COINS = 'LOADING_COINS';
export const STOP_LOADING_COINS = 'STOP_LOADING_COINS';